/**
 * @todo
 * - Evaluate {@link RESOURCE_LOADER} concept (should not belong to ResourceElement, but be kind of global)
 * - Get rid of this module.
 *
 * @module
 */

const UUID_STARGAZER_RESOURCE = "3d282485-64e4-4b6e-96f1-be43283e29b4";

/**
 * @internal
 */
export const REGISTRY_ELEMENT = Symbol.for(UUID_STARGAZER_RESOURCE);
